import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ascoltaNonLetti, messaggiCambiati, segnaLetto } from '../../services/messaggiApi';
import './styles/FinestraGiroconto.css';
import './styles/FinestraImportante.css';

/**
 * IL MESSAGGIO IMPORTANTE, che si apre da solo.
 *
 * Il backoffice puo' segnare un messaggio come importante: chi lo riceve lo
 * trova aperto in una finestra appena entra (o entro un minuto, se e' gia'
 * dentro), e la finestra se ne va con «Ho letto», che lo segna letto. Se ce
 * n'e' piu' di uno, arriva il successivo.
 *
 * La X e lo sfondo la chiudono senza segnarlo: torna al prossimo accesso,
 * ma non in questa pagina, per non inseguire chi l'ha chiusa apposta.
 */
export default function FinestraImportante() {
  const { t } = useTranslation();
  const posizione = useLocation();
  const [importante, setImportante] = useState(null);
  const [inCorso, setInCorso] = useState(false);
  const chiusi = useRef(new Set());
  const gettone = useRef(null);

  useEffect(() => ascoltaNonLetti((stato) => {
    const m = stato && stato.importante;
    setImportante(m && !chiusi.current.has(m.id) ? m : null);
  }), []);

  /* Entrare non cambia il gettone in un'altra scheda, ma in questa: a ogni
     cambio di pagina si guarda se e' cambiato, e se si' si rilegge. */
  useEffect(() => {
    const ora = window.localStorage.getItem('access_token');
    if (ora !== gettone.current) {
      gettone.current = ora;
      chiusi.current.clear();
      messaggiCambiati();
    }
  }, [posizione.pathname]);

  useEffect(() => {
    if (!importante) return undefined;
    const tasto = (e) => { if (e.key === 'Escape') chiudi(); };
    window.addEventListener('keydown', tasto);
    return () => window.removeEventListener('keydown', tasto);
  });

  if (!importante) return null;

  function chiudi() {
    chiusi.current.add(importante.id);
    setImportante(null);
  }

  async function hoLetto() {
    setInCorso(true);
    try {
      await segnaLetto(importante.id);
    } catch (e) {
      // non segnato: torna al prossimo giro, intanto non blocca chi vuole andare avanti
    }
    setInCorso(false);
    chiudi();
  }

  return createPortal(
    <div className="fin-fondo" role="dialog" aria-modal="true" aria-labelledby="importante-titolo"
         onClick={(e) => { if (e.target === e.currentTarget) chiudi(); }}>
      <div className="finestra finestra-importante">
        <div className="f-testa">
          <span className="segno">{t('Importante')}</span>
          <h2 id="importante-titolo">{importante.titolo}</h2>
          <button type="button" className="chiudi-x" aria-label={t('Chiudi')} onClick={chiudi}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>
        <div className="f-corpo-importante">{importante.testo}</div>
        <div className="f-pie">
          <Link to="/my-account/messaggi" className="bott vedi-tutti" onClick={chiudi}>{t('Tutti i messaggi')}</Link>
          <button type="button" className="bott principale" onClick={hoLetto} disabled={inCorso}>
            {t('Ho letto')}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
